<template>
    <div>
        <h1>Narrative</h1>
        <hr>
        <fieldset :disabled="formDisabled">
            <b-row>
                <b-col>
                    <div id="description" class="field-labels">
                        Description
                    </div>
                    <b-form-textarea id="description-textarea" v-model="form.description" :rows="3" />
                    <div v-if="needsToShowPrevious" class="diff-area">
                        <!-- eslint-disable-next-line vue/no-v-html -->
                        <div v-html="diffLabel('Description')" />
                        <!-- eslint-disable-next-line vue/no-v-html -->
                        <div v-html="diff.description" />
                    </div>
                </b-col>
            </b-row>
            <hr>
            <b-row>
                <b-col>
                    <div id="justification" class="field-labels">
                        Justification
                    </div>
                    <b-form-textarea
                        id="justification-textarea"
                        v-model="form.justification"
                        :rows="3"
                    />
                    <div v-if="needsToShowPrevious" class="diff-area">
                        <!-- eslint-disable-next-line vue/no-v-html -->
                        <div v-html="diffLabel('Justification')" />
                        <!-- eslint-disable-next-line vue/no-v-html -->
                        <div v-html="diff.justification" />
                    </div>
                </b-col>
            </b-row>
            <hr>
            <b-row>
                <b-col>
                    <div id="benefit" class="field-labels">
                        Benefit
                    </div>
                    <b-form-textarea id="benefit-textarea" v-model="form.benefit" :rows="3" />
                    <div v-if="needsToShowPrevious" class="diff-area">
                        <!-- eslint-disable-next-line vue/no-v-html -->
                        <div v-html="diffLabel('Benefit')" />
                        <!-- eslint-disable-next-line vue/no-v-html -->
                        <div v-html="diff.benefit" />
                    </div>
                </b-col>
            </b-row>
        </fieldset>
        <hr>
        <b-row>
            <b-col>
                <moduleActions
                    :is-loading="isSaving"
                    background-color="#006438"
                    :is-disabled="formDisabled"
                    @saveForm="saveForm"
                />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { Arc, Log } from '$Shared/@arc/vue-arc';
// import { Diff } from 'diff/dist/diff';

export default {
    name: 'Narrative',
    props: {
        formDisabled: { type: Boolean, default: true },
    },

    data() {
        return {
            form: {
                description: null,
                justification: null,
                benefit: null,
            },
            diff: {
                description: null,
                justification: null,
                benefit: null,
            },
            isSaving: false,
        };
    },

    computed: {
        ...mapGetters({
            moduleData: 'module/moduleData',
            moduleDataPrevious: 'module/moduleDataPrevious',
            needsToShowPrevious: 'review/needsToShowPrevious',
            previousProposalNarrative: 'review/previousProposalNarrative',
        }),

        payload() {
            return {
                content: { ...this.form },
            };
        },
    },

    async created() {
        this.form = { ...this.form, ...Arc.Objects.clone(this.moduleData.content) };

        if (!Arc.Objects.isEmpty(this.previousProposalNarrative)) {
            // generate color coded diff text
            this.diff.description = this.getColoredDiff(
                this.previousProposalNarrative.description,
                this.form.description
            );
            this.diff.justification = this.getColoredDiff(
                this.previousProposalNarrative.justification,
                this.form.justification
            );
            this.diff.benefit = this.getColoredDiff(
                this.previousProposalNarrative.benefit,
                this.form.benefit
            );
        }
    },

    methods: {
        ...mapActions({
            saveModule: 'module/saveModule'
        }),

        async saveForm() {
            this.isSaving = true;
            try {
                const { data } = await this.saveModule(this.payload);
                this.isSaving = false;
                Log.debug(data, `COMPONENT:${this.name} -> Save module response:`);
            } catch (error) {
                console.log(error);
                this.isSaving = false;
            }
        },

        diffLabel(text) {
            return (
                '<span class="field-labels">' + text + ' Changes ' +
                '</span> (text colors: ' +
                '<span class="diff-removed">removed</span>, ' +
                '<span class="diff-added">added</span>, ' +
                'unchanged)'
            );
        },

        getColoredDiff(oldStr, newStr) {
            // TODO: ask Nathan to fix this so we import it the right way
            let Diff = require('diff/dist/diff');
            let diff = Diff.diffWords(oldStr, newStr);

            let retStr = '';
            diff.forEach((part) => {
                if (part.added) {
                    retStr += '<span class="diff-added">' + part.value + ' </span>';
                } else if (part.removed) {
                    retStr += '<span class="diff-removed">' + part.value + ' </span>';
                } else {
                    retStr += part.value;
                }
            });

            return retStr;
        },
    },
};
</script>

<style scoped lang="scss">
@import "$StyleVars";

h1 {
    font-size: 1.5rem;
    text-align: left;
    font-weight: bold;
    color: $ace-purple;
}
.field-labels {
    font-size: 1rem;
    font-weight: bold;
    text-align: left;
    color: $ace-purple;
    margin-bottom: .25rem;
}
div .diff-area {
    text-align: left;
}

/*
    note: the `div >>>` syntax is a little funky, but it's the only way to get
    these classes to work when in a `scoped` style used in v-html
    interpolation. It also means they will only work when they have an
    enclosing <div>, which is pretty likely.
*/
div /deep/ .diff-added {
    color: green;
}
div /deep/ .diff-removed {
    color: red;
}
</style>
